import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { translate } from '@fiverr-private/i18n-react';
import Link from '../Links/Link';
import { HEADER_NAV_SOURCE } from '../../constants';

export const PersonalAssistantLink: React.FC = () => {
    const href = pathfinder('seller_ai_hub_page', {}, { query: { source: HEADER_NAV_SOURCE } });

    return (
        <Link href={href} className="nav-link" isNew>
            {translate('header.fiverr_go')}
        </Link>
    );
};
